import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SetColorsService {

  getKnowledgeColor(knowledgeType: string): string {
    switch (knowledgeType) {
      case "Podstawowa":
        return "#D1D5DB";
      case "Specjalistyczna":
        return "#9CA3AF";
      default:
        return "#D1D5DB";
    }
  }
}
